import { useAccount } from './AccountContext';
import { useQuery } from 'react-query';
import { getPointsForUser, MissionsCompleted } from '../utils/PointsAPI';
import { queryKeys } from './QueryClient';

type UserPointsResponse = {
  points: number;
  totalPoints: number;
  summary: MissionsCompleted[];
};

const getPoints = async (userId: string): Promise<UserPointsResponse> => {
  const { points, totalPoints, summary } = await getPointsForUser(userId);
  return { points: Number(points), totalPoints, summary };
};

export const useUserPoints = () => {
  const { account } = useAccount();
  const accountId = account.dusktech?.userId;
  return useQuery(
    queryKeys.userPoints(accountId),
    () => {
      if (!accountId) {
        throw Error('No account');
      }
      return getPoints(accountId);
    },
    {
      enabled: Boolean(accountId),
      // store the user's points for 5 minutes
      cacheTime: 1000 * 60 * 5,
      // only refetch after 1 minute
      staleTime: 1000 * 60,
      refetchOnWindowFocus: false,
    },
  );
};
